/**
 * Commercial name: SEO-Presta
 * Proprietary-license whose copyright belongs to the Licensor PRESTA MODULE, a company registered under French law
 * under the number 528 531 767, located 90 rue Stanislas Torrents 13006 Marseille
 * support@presta-module.com https://www.presta-module.com
 *
 * SEO-Presta’ source codes are protected and Licensees are not allowed to create any Derivated Work.
 * The distribution or resale of SEO-Presta is strictly forbidden.
 *
 * SEO-Presta shall be used for Licensees’ own use, which allows Customization.
 *
 * Licensees shall not distribute nor resale publicly any Customization of SEO-Presta. However, Licensees are allowed
 * to sale a customization of SEO-Presta as part of a service provided to a designated customer.
 *
 * Limitation of Liability: Under no circumstances and under no legal theory, whether in tort (including negligence),
 * contract, or otherwise, shall the Licensor be liable to anyone for any indirect, special, incidental, or
 * consequential damages of any character arising as a result of this License including, without limitation, damages
 * for loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages
 * or losses. This limitation of liability shall not apply to the extent applicable law prohibits such limitation.
 *
 * Attribution notice: SEO-Presta is a Derivated Work from an Original Work created by PrestaShop SA
 * and its contributors which can be found at https://github.com/PrestaShop/PrestaShop
 */

import getQueryParameters from './urlparser';
import NumberFormatter from '../cldr/number-formatter';

const formatters = {};

const displayLabelBlock = (formatterId, displayBlock, min, max) => {
    if (formatters[formatterId] === undefined) {
        displayBlock.text(
            displayBlock.text().replace(
                /([^\d]*)(?:[\d .,]+)([^\d]+)(?:[\d .,]+)(.*)/,
                `$1${min}$2${max}$3`,
            ),
        );
    } else {
        displayBlock.text(
            `${formatters[formatterId].format(min)} - ${formatters[formatterId].format(max)}`,
        );
    }
};

/**
 * Refresh facets sliders
 */
const refreshSliders = () => {
    $('.faceted-slider').each(function initializeSliders() {
        const $el = $(this);
        const values = $el.data('slider-values');
        const specifications = $el.data('slider-specifications');
        if (specifications !== null && specifications !== undefined) {
            formatters[$el.data('slider-id')] = NumberFormatter.build(specifications);
        }

        displayLabelBlock(
            $el.data('slider-id'),
            $(`#facet_label_${$el.data('slider-id')}`),
            values === null ? $el.data('slider-min') : values[0],
            values === null ? $el.data('slider-max') : values[1],
        );

        $(`#slider-range_${$el.data('slider-id')}`).slider({
            range: true,
            min: $el.data('slider-min'),
            max: $el.data('slider-max'),
            values: [
                values === null ? $el.data('slider-min') : values[0],
                values === null ? $el.data('slider-max') : values[1],
            ],
            stop(event, ui) {
                const nextEncodedFacetsURL = $el.data('slider-encoded-url');
                const urlsSplitted = nextEncodedFacetsURL.split('?');
                let queryParams = [];

                // Retrieve parameters if exists
                if (urlsSplitted.length > 1) {
                    queryParams = getQueryParameters(urlsSplitted[1]);
                }

                let found = false;
                queryParams.forEach((query) => {
                    if (query.name === 'q') {
                        found = true;
                    }
                });

                if (!found) {
                    queryParams.push({ name: 'q', value: '' });
                }

                // Update query parameter
                queryParams.forEach((query) => {
                    if (query.name === 'q') {
                        // eslint-disable-next-line
                        query.value += [
                            query.value.length > 0 ? '/' : '',
                            $el.data('slider-label'),
                            '-',
                            $el.data('slider-unit'),
                            '-',
                            ui.values[0],
                            '-',
                            ui.values[1],
                        ].join('');
                    }
                });

                const requestUrl = [
                    urlsSplitted[0],
                    '?',
                    $.param(queryParams),
                ].join('');

                prestashop.emit(
                    'updateFacets',
                    requestUrl,
                );
            },
            slide(event, ui) {
                displayLabelBlock(
                    $el.data('slider-id'),
                    $(`#facet_label_${$el.data('slider-id')}`),
                    ui.values[0],
                    ui.values[1],
                );
            },
        }); // sliders desktop

        $(`#slider-range-mobile_${$el.data('slider-mobile-id')}`).slider({
            range: true,
            min: $el.data('slider-min'),
            max: $el.data('slider-max'),
            values: [
                values === null ? $el.data('slider-min') : values[0],
                values === null ? $el.data('slider-max') : values[1],
            ],
            stop(event, ui) {
                const nextEncodedFacetsURL = $el.data('slider-encoded-url');
                const urlsSplitted = nextEncodedFacetsURL.split('?');
                let queryParams = [];

                // Retrieve parameters if exists
                if (urlsSplitted.length > 1) {
                    queryParams = getQueryParameters(urlsSplitted[1]);
                }

                let found = false;
                queryParams.forEach((query) => {
                    if (query.name === 'q') {
                        found = true;
                    }
                });

                if (!found) {
                    queryParams.push({ name: 'q', value: '' });
                }

                // Update query parameter
                queryParams.forEach((query) => {
                    if (query.name === 'q') {
                        // eslint-disable-next-line
                        query.value += [
                            query.value.length > 0 ? '/' : '',
                            $el.data('slider-label'),
                            '-',
                            $el.data('slider-unit'),
                            '-',
                            ui.values[0],
                            '-',
                            ui.values[1],
                        ].join('');
                    }
                });

                const requestUrl = [
                    urlsSplitted[0],
                    '?',
                    $.param(queryParams),
                ].join('');

                prestashop.emit(
                    'updateFacets',
                    requestUrl,
                );
            },
            slide(event, ui) {
                displayLabelBlock(
                    $el.data('slider-mobile-id'),
                    $(`#facet_label-mobile_${$el.data('slider-mobile-id')}`),
                    ui.values[0],
                    ui.values[1],
                );
            },
        });// slider mobiles
    });
};

export default refreshSliders;
